<script lang="ts">
  import { confirmDialog, resolveConfirm } from '../stores/confirmDialog';
  import Modal from './Modal.svelte';
  import { t } from '../i18n/index.ts';
</script>

{#if $confirmDialog.show}
  <Modal title={t('componentsConfirmTitle')} zIndex={70} onclose={() => resolveConfirm(false)}>
    <p class="text-sm">{$confirmDialog.message}</p>
    <div class="flex justify-end gap-2">
      <button class="btn btn-secondary" onclick={() => resolveConfirm(false)}>{t('appCancel')}</button>
      <button class="btn btn-danger" onclick={() => resolveConfirm(true)}>{t('componentsConfirmButton')}</button>
    </div>
  </Modal>
{/if}
